import React from 'react';
import {
  withStyles,
  MuiThemeProvider,
  Button,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  TableContainer,
  Typography,
  Box,
  InputLabel,
  TextField,
  MenuItem,
  InputAdornment,
  Divider,
  FormGroup,
} from '@material-ui/core';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FunctionsPageHeader from './function_page_header/functions_page_header';
import _Checkbox from './checkbox/checkbox';
import PasswordField from './password_field/password_field';
import PhoneNumber from './phone_number/phone_number';
import useTranslateText from './use_translate_text';
import useCharHide from './use_char_hide';
import useNumericValue from './use_numeric_value';
import useShowPassword from './use_show_password';
import useStringArray from './use_string_array';
import useUserImg from './use_user_img';
import useRoutePath from './use_route_path';
import useVolSelfID from './use_vol_self_id';
import useLogOut from './use_logout';
import { translateText } from './translate_text';
import { formLabelsTheme } from '../style_jsx/styles';
import CircularProgress from './circular_progress/circular_progress';
import CircularProgressButton from './circular_progress/circular_progress_button';
import UserContext, { UserConsumer, UserProvider } from './global_context';
import { getCookie, setCookie, removeCookie } from './cookie_storage';
import { getValue, setValue, removeValue } from './data_storage';
import APICallManager from '../services/api_manager';
import config from '../config.js';
import ProgressIndicator from './progress_indiator/progress-indicator';
import bootstrap from 'bootstrap';
import bootbox from 'bootbox';
import { isFutureDate, isPastDate } from './is_future_Date/is_in_future_date';
// import { currentSlide } from '../components/sidebar/sidebar_functions';
import * as CardInformation from './card_information/card_information';
import SortableTable from './table_and_charts/sortable_table';
import CircularCharts from './table_and_charts/circular_charts';
import PopupModal from './popup_modal';
import { pipeSaperatedString } from './utils/string_utils';
import * as Buttons from './primary_button';
import * as Links from './primary_link';
import InputForm from './input_form/input_form';
import InputFormI9 from './input_form/input_formi9';
import InputFormEvents from './input_form/input_formEvents';
import InputRadio from './input_form/input_radio';
import DatePicker, { Date_Picker_Wrapper } from './datepicker/datepicker';
import { convertDate as convert } from './datepicker/convert';
import Dropdown from './dropdown/dropdown';
import useWindowDimensions from './use_Window_Dimensions';
import SSNFieldComponent from './social_security_number/social_security_number';
import functionNames from '../functionNames.json';
import usePermissionValue from './use_permission_value';
import { srcPath } from './get_src_path';
import RadioButton from './radio_button/radio_button';
import useUspsValidation from './use_usps_validation';
import { context as storeContext } from '../store/store';
import Toast from './toast/toast';

const circularProgress = <Box style={{ marginTop: '4rem' }}><CircularProgress /></Box>;

export const commonNodeModules = {
  InputLabel,
  TextField,
  MenuItem,
  Button,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  TableHead,
  Box,
  InputAdornment,
  Typography,
  bootstrap,
  bootbox,
  FontAwesomeIcon,
  withStyles,
  MuiThemeProvider,
  Divider,
  FormGroup,
  isFutureDate,
  isPastDate,
};

export const commonModules = {
  UserContext, UserConsumer, UserProvider, FunctionsPageHeader, useTranslateText, useCharHide, useShowPassword,
  useStringArray, useNumericValue, useUserImg, CircularProgress, setCookie, getCookie, removeCookie, getValue,
  setValue, removeValue, APICallManager, config, translateText, ProgressIndicator, Dropdown, DatePicker,
  InputForm, InputFormI9, InputFormEvents, InputRadio, /* currentSlide ,*/ SortableTable, CircularCharts, PopupModal, pipeSaperatedString,
  ...CardInformation, ...Buttons, ...Links, formLabelsTheme, Date_Picker_Wrapper, SSNFieldComponent, useLogOut,
  useRoutePath, functionNames, usePermissionValue, convert, RadioButton, PasswordField, _Checkbox, PhoneNumber,
  useVolSelfID, srcPath, useWindowDimensions, circularProgress, useUspsValidation, storeContext, CircularProgressButton,
  Toast };
